import { isRelativeFilterConditionValueType, } from "../../../Domain/ReportBuilder/FilterCondition.model";
import FilterFieldType from "../../../Domain/ReportBuilder/FilterFieldType";
import { isArgumentlessOperator } from "../../../Domain/ReportBuilder/FilterOperator.model";
function mapFilterConditionForValueEntry(fc) {
    // As a part of this mapping, we need to detect relative date filters that are in "ago" mode by checking for a
    // filter value type of "relative" (there are several), and a value that is less than 0. We then set the value to a
    // positive value and set the mode to "ago" instead of "from now".
    let relativeOption = "fromNow";
    let { value } = fc;
    if (value &&
        parseInt(value, 10) < 0 &&
        isRelativeFilterConditionValueType(fc.filterConditionValueType)) {
        relativeOption = "ago";
        value = Math.abs(parseInt(value, 10)).toString();
    }
    const mappedFilterCondition = {
        filterSourceColumnId: fc.filterSourceColumn.id,
        filterSourceColumn: fc.filterSourceColumn,
        filterSourceRelationshipId: fc.filterSourceRelationship
            ? fc.filterSourceRelationship.id
            : null,
        filterSourceRelationship: fc.filterSourceRelationship,
        operatorName: fc.filterOperator,
        filterOperator: fc.filterOperator,
        value,
        displayValue: fc.displayValue,
        prompt: fc.prompt,
        notThisCondition: fc.notThisCondition,
        filterConditionValueType: fc.filterConditionValueType,
        relativeOption,
    };
    return mappedFilterCondition;
}
function getFilterValue(filterCondition) {
    if (filterCondition.value &&
        isRelativeFilterConditionValueType(filterCondition.filterConditionValueType)) {
        const val = parseInt(filterCondition.value, 10);
        if (filterCondition.relativeOption === "ago") {
            return (-val).toString();
        }
        return val.toString();
    }
    return filterCondition.value;
}
function validateFilterCondition(fc, filterSourceColumns) {
    const currentValidationErrors = [];
    let foundFsc = fc.filterSourceColumn;
    if (!foundFsc) {
        foundFsc = filterSourceColumns
            .map((fsc) => fsc.filterSourceColumn)
            .find((fsc) => fsc.id === fc.filterSourceColumnId);
    }
    let filterColumnName = fc.filterSourceColumn
        ? fc.filterSourceColumn.displayName
        : "";
    if (!filterColumnName) {
        filterColumnName = foundFsc ? foundFsc.displayName : "";
    }
    if (fc.filterSourceColumnId !== null &&
        fc.filterSourceColumnId !== undefined) {
        // Operator is required.
        if (!fc.operatorName) {
            currentValidationErrors.push(`An operator must be selected for the filter on "${filterColumnName}".`);
        }
    }
    // If it's an argument-less filter, then don't require a value, so skip value validation
    if (isArgumentlessOperator(fc.operatorName)) {
        return currentValidationErrors;
    }
    // Begin value validation --------
    // If it's a numeric column, the value must be numeric.
    if (foundFsc && foundFsc.filterFieldType === FilterFieldType.NUMERIC) {
        if (Number.isNaN(Number(fc.value))) {
            currentValidationErrors.push(`The value for the filter on "${filterColumnName}" must be numeric.`);
        }
    }
    return currentValidationErrors;
}
export { mapFilterConditionForValueEntry, getFilterValue, validateFilterCondition, };
